import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  horizontalDivider: {
    margin: '24px 0'
  }
});
